import {lazy} from 'react'
import Agreement from '../pages/contribute/agreement'
/* login */
const Login = lazy(() => import('@/pages/login'))
const LoginType = lazy(() => import('@/pages/login/components/login-type'))
const LoginProtocol = lazy(() => import('@/pages/login/components/protocol'))

/* Register */
const Register = lazy(() => import('@/pages/register'))
const RegisterProtocol = lazy(() => import('@/pages/register/components/protocol'))
const RegisterInfo = lazy(() => import('@/pages/register/components/register-info'))
const RegisterAuthentication = lazy(() => import('@/pages/register/components/authentication'))
const RegisterAuthenticationView = lazy(() => import('@/pages/register/components/authentication-view'))
const FilterHospital = lazy(() => import('@/pages/register/components/filter-search/filter-hospital'))
const FilterDepartment = lazy(() => import('@/pages/register/components/filter-search/filter-department'))
const FilterDepartmentName = lazy(() => import('@/pages/register/components/filter-search/filter-department-name'))
const FilterjobTitle = lazy(() => import('@/pages/register/components/filter-search/filter-job-title'))
const FilterMode = lazy(() => import('@/pages/register/components/filter-search/filter-mode'))
const SelectRole = lazy(() => import('@/pages/register/components/select-role'))
const BindEmail = lazy(() => import('@/pages/register/components/bind-email'))
const SelectMode = lazy(() => import('@/pages/register/components/select-mode'))

/* home */
const Home = lazy(() => import('@/pages/home'))

/* 医生主页 */
const DoctorHome = lazy(() => import('@/pages/doctor-home'))
/* 医生主页-专辑详情 */
const AlbumDetail = lazy(() => import('@/pages/album-detail'))

/* 科室主页 */
const DepartmentHome = lazy(() => import('@/pages/department-home'))

/* 医院主页 */
const HospitalHome = lazy(() => import('@/pages/hospital-home'))

/* 医生名片 */
const DoctorCard = lazy(() => import('@/pages/doctor-card'))

/* 对外信息 */
const ExternalInfo = lazy(() => import('@/pages/external-info'))

/* 出版物详情 */
const PublicationDetail = lazy(() => import('@/pages/publication-detail'))

/* 活动详情 */
const ActiveDetail = lazy(() => import('@/pages/active-detail'))

/* 活动总结分享 */
const ActiveSummary = lazy(() => import('@/pages/activity-summary'))

/* 活动总结app嵌入 */
const ActiveSummaryApp = lazy(() => import('@/pages/activity-summary-app'))

/* 直播时刻分享 */
const ActiveLiveTime = lazy(() => import('@/pages/active-live-time'))

/* 全部活动 */
const AllActivity = lazy(() => import('@/pages/all-activity'))

/* 活动详情-简介 */
const ActiveDetailBrief = lazy(() => import('@/pages/active-detail-brief-app'))

/* 邀请有礼活动 */
const PoliteInvitation = lazy(() => import('@/pages/polite-invitation'))
const MyInvitation = lazy(() => import('@/pages/polite-invitation/my'))

/* 视频播放 */
const VideoPlay = lazy(() => import('@/pages/video-play'))

/* 活动精选详情 */
const featuredActivity = lazy(() => import('@/pages/featured-events-detail'))

/* 活动精选列表 */
const featuredActivityList = lazy(() => import('@/pages/activity-list'))

/* 员工主页 */
const employerHome = lazy(() => import('@/pages/employer-home'))

/* 话题首页 */
const topicHome = lazy(() => import('@/pages/topic-home'))
/* 话题详情 */
const topicDetail = lazy(() => import('@/pages/topic-detail'))

/* 直播首页 */
const LiveHome = lazy(() => import('@/pages/live-home'))
/* 星光直播首页 */
const LiveLightHome = lazy(() => import('@/pages/live-light-home'))
/* 直播 - 直播时刻 */
const LiveList = lazy(() => import('@/pages/live-list'))
/* 直播中 */
const LiveRoomList = lazy(() => import('@/pages/live-room-list'))
/* 直播间 */
const LiveRoom = lazy(() => import('@/pages/live-room'))
/* 直播间 - 去除token */
const LiveRoomNo = lazy(() => import('@/pages/live-room-no'))
/* 博鳌外科-直播间 */
const LiveRoomSurgery = lazy(() => import('@/pages/live-room-surgery'))

/* 热图 */
const HeatMap = lazy(() => import('@/pages/heat-map'))

/* 讨论组详情 */
const GroupDetail = lazy(() => import('@/pages/discussion-group'))

/* 404 */
const NotFound = lazy(() => import('@/pages/not-found'))

/* Demo */
const Demo = lazy(() => import('@/pages/demo'))
/* 投票管理 */
const Vote = lazy(() => import('@/pages/vote-manage'))

/* 赛事列表 */
const matchList = lazy(() => import('@/pages/match-list'))

/* 频道 */
const Channel = lazy(() => import('@/pages/channel'))

/* 频道分类详情 */
const ChannelClassify = lazy(() => import('@/pages/channel/channel-classify'))

/* 频道详情 */
const ChannelDetail = lazy(() => import('@/pages/channel/channel-detail'))

/* 子栏目详情 */
const ColumnDetail = lazy(() => import('@/pages/channel/column-detail'))

/* app分享的外链 */
const ExternalLinks = lazy(() => import('@/pages/external-links'))
/* 直播中-我的关注/订阅列表 */
const Subscribe = lazy(() => import('@/pages/subscribe'))

/* 直播中-推荐列表 */
const LiveRecommend = lazy(() => import('@/pages/live-recommend'))

/* 手术直播 */
const LiveSurgery = lazy(() => import('@/pages/live-surgery'))

/* 会议直播 */
const LiveConference = lazy(() => import('@/pages/live-conference'))

/* 直播预告-推荐列表 */
const LivePreview = lazy(() => import('@/pages/live-preview'))

/* 热门专区-首页 */
const Celebrity = lazy(() => import('@/pages/celebrity'))

/* 热门专区-医生主页 */
const CelebrityDoctor = lazy(() => import('@/pages/celebrity/components/doctor'))

/* 热门专区-科室主页 */
const CelebrityDept = lazy(() => import('@/pages/celebrity/components/dept'))

/* 热门专区-医院主页 */
const CelebrityHospital = lazy(() => import('@/pages/celebrity/components/hospital'))

/* 术式分类-单个术式主页 */
const Surgical = lazy(() => import('@/pages/surgical/detail'))

/* 术式分类-类别列表 */
const SurgicalClassify = lazy(() => import('@/pages/surgical'))

/* 专题栏目-列表 */
const SubjectList = lazy(() => import('@/pages/subject'))

/* 专题栏目-详情 */
const SubjectDetail = lazy(() => import('@/pages/subject/detail.js'))

/* 博鳌访谈 */
const Interview = lazy(() => import('@/pages/interview'))

/* 选择PDF */
const PdfDetail = lazy(() => import('@/pages/pdf-detail'))
const AgreementPdf = lazy(() => import('@/pages/pdf-detail/agreement'))

/* 新用户推荐 */
const UserRecommend = lazy(() => import('@/pages/user-recommend'))

const QrCode = lazy(() => import('@/pages/qr-code'))
const ContributeIndex = lazy(() => import('@/pages/contribute/index'))
const ContributeList = lazy(() => import('@/pages/contribute/list'))
const ContributeLog = lazy(() => import('@/pages/contribute/log'))
const ContributeAgreement = lazy(() => import('@/pages/contribute/agreement/index.js'))

const ContributeIndexV2 = lazy(() => import('@/pages/contribute-v2/index'))
const ContributeListV2 = lazy(() => import('@/pages/contribute-v2/list'))
const ContributeLogV2 = lazy(() => import('@/pages/contribute-v2/log'))
const ContributeAgreementV2 = lazy(() => import('@/pages/contribute-v2/agreement/index.js'))
const SystemLocalClean = lazy(() => import('@/pages/h5System/index.js'))
const ActiveScalpel = lazy(() => import('@/pages/active-page/scalpel-active/index.js'))

const ContributeIndexPage = lazy(() => import('@/pages/common-contribute/contribute/index'))
const ContributeListPage = lazy(() => import('@/pages/common-contribute/contribute/list'))
const ContributeLogPage = lazy(() => import('@/pages/common-contribute/contribute/log'))
const ContributeAgreementPage = lazy(() => import('@/pages/common-contribute/contribute/agreement/index.js'))
const ContributeActivePage = lazy(() => import('@/pages/common-contribute-active/index'))

/** 直播回放列表 */
const PlaybackList = lazy(() => import('@/pages/playback-list'))
const FriendCircleList = lazy(() => import('@/pages/friend-circle-list'))

/** 付费课程首页 */
const CourseHome = lazy(() => import('@/pages/course'))
/** 我的课程 */
const MyCourse = lazy(() => import('@/pages/course/my-course'))
/** 订单详情 */
const CourseOrder = lazy(() => import('@/pages/course/course-order'))
/** 课程详情 */
const CourseDetail = lazy(() => import('@/pages/course/course-detail'))
/** 课程播放页 */
const CoursePlay = lazy(() => import('@/pages/course/course-play'))
/** 课程支付页 */
const CoursePay = lazy(() => import('@/pages/course/course-pay'))

const routes = [
  {path: '/home', exact: true, component: Home, title: '术友圈'},
  {path: '/register', exact: true, component: Register, title: '博鳌医学'},
  {path: '/protocol', exact: true, component: RegisterProtocol, title: '博鳌医学用户协议'},
  {path: '/register-info/', exact: true, component: RegisterInfo, title: '博鳌医学'},
  {path: '/register-info/filter-search/hospital', exact: true, component: FilterHospital, title: '请选择医院'},
  {
    path: '/register-info/filter-search/department/:id',
    exact: true,
    component: FilterDepartment,
    title: '请选择科室'
  },
  {
    path: '/register-info/filter-search/department-name',
    exact: true,
    component: FilterDepartmentName,
    title: '请选择科室名称'
  },
  {path: '/register-info/filter-search/job-title', exact: true, component: FilterjobTitle, title: '请选择职称'},
  {path: '/register-info/filter-search/mode', exact: true, component: FilterMode, title: '主术士标签'},
  {path: '/register-info/authentication', exact: true, component: RegisterAuthentication, title: '实名认证'},
  {path: '/register-info/authentication-view', exact: true, component: RegisterAuthenticationView, title: '实名认证'},
  {path: '/register-info/select-role', exact: true, component: SelectRole, title: '选择身份'},
  {path: '/register-info/bind-email', exact: true, component: BindEmail, title: '商务绑定邮箱'},
  {path: '/register-info/select-mode', exact: true, component: SelectMode, title: '商务注册'},
  {path: '/register-info/select-mode-all', exact: true, component: SelectMode, title: '商务注册'},
  {path: '/login', exact: true, component: Login, title: '博鳌医学'},
  {path: '/login-type/:type', exact: true, component: LoginType, title: '博鳌医学'},
  {path: '/login-protocol', exact: true, component: LoginProtocol, title: '博鳌医学用户协议'},
  {path: '/doctor-home', exact: true, component: DoctorHome, title: '个人主页'},
  {path: '/doctor/album_detail', exact: true, component: AlbumDetail, title: '专辑详情'},
  {path: '/department-home', exact: true, component: DepartmentHome, title: '科室主页'},
  {path: '/hospital-home', exact: true, component: HospitalHome, title: '医院主页'},
  {path: '/doctor-card/:type', exact: true, component: DoctorCard, title: '医生名片'},
  {path: '/external-info', exact: true, component: ExternalInfo, title: '对外信息'},
  {path: '/publication-detail/:type', exact: true, component: PublicationDetail, title: '出版物详情'},
  {path: '/active-detail', exact: true, component: ActiveDetail, title: '活动详情'},
  {path: '/activity-summary', exact: true, component: ActiveSummary, title: '活动总结'},
  {path: '/activity-summary-app', exact: true, component: ActiveSummaryApp, title: '活动总结'},
  {path: '/active-live-time', exact: true, component: ActiveLiveTime, title: '活动详情'},
  {path: '/activity-detail-brief-app', exact: true, component: ActiveDetailBrief, title: '活动详情简介'},
  {path: '/polite-invitation', exact: true, component: PoliteInvitation, title: '邀请有礼'},
  {path: '/my-invitation', exact: true, component: MyInvitation, title: '我的邀请'},
  {path: '/video-play', exact: true, component: VideoPlay, title: '视频'},
  {path: '/featured-activity', exact: true, component: featuredActivity, title: '活动精选详情'},
  {path: '/featured-activity-list', exact: true, component: featuredActivityList, title: '活动精选列表'},
  {path: '/employer-home', exact: true, component: employerHome, title: '商务主页'},
  {path: '/topic-home', exact: true, component: topicHome, title: '话题首页'},
  {path: '/topic-detail', exact: true, component: topicDetail, title: '话题详情'},
  {path: '/live-home', exact: true, component: LiveHome, title: '直播首页'},
  {path: '/live-light-home', exact: true, component: LiveLightHome, title: '星光直播首页'},
  {path: '/live-list', exact: true, component: LiveList, title: '直播'},
  {path: '/live-room-list', exact: true, component: LiveRoomList, title: '直播间'},
  {path: '/live-room/:roomId?', exact: true, component: LiveRoom, title: '详情'},
  {path: '/live-room-surgery/:roomId', exact: true, component: LiveRoomSurgery, title: '详情'},
  {path: '/live-room-no/:roomId', exact: true, component: LiveRoomNo, title: '详情'},
  {path: '/heat-map', exact: true, component: HeatMap, title: ''},
  {path: '/discussion-group', exact: true, component: GroupDetail, title: '讨论组详情'},
  {path: '/all-activity', exact: true, component: AllActivity, title: '全部活动'},
  {path: '/404', exact: true, component: NotFound},
  {path: '/demo', exact: true, component: Demo},
  {path: '/vote/:type', exact: true, component: Vote},
  {path: '/match-list', exact: true, component: matchList, title: '赛事列表'},
  {path: '/channel', exact: true, component: Channel, title: '频道'},
  {path: '/channel-classify', exact: true, component: ChannelClassify, title: '频道分类'},
  {path: '/channel-detail', exact: true, component: ChannelDetail, title: '频道详情'},
  {path: '/column-detail', exact: true, component: ColumnDetail, title: '子栏目'},
  {path: '/external-links', exact: true, component: ExternalLinks, title: '外链'},
  {path: '/subscribe', exact: true, component: Subscribe, title: '我的订阅'},
  {path: '/live-recommend', exact: true, component: LiveRecommend, title: '直播中'},
  {path: '/live-surgery', exact: true, component: LiveSurgery, title: '手术直播'},
  {path: '/live-conference', exact: true, component: LiveConference, title: '会议直播'},
  {path: '/live-preview', exact: true, component: LivePreview, title: '直播预告'},
  {path: '/celebrity', exact: true, component: Celebrity, title: '热门专区'},
  {path: '/celebrity-doctor/:doctorId', exact: true, component: CelebrityDoctor, title: '医生姓名精彩汇聚'},
  {path: '/celebrity-dept/:deptId', exact: true, component: CelebrityDept, title: '科室名称精彩汇聚'},
  {path: '/celebrity-hospital/:hospitalId', exact: true, component: CelebrityHospital, title: '医院名称精彩汇聚'},
  {path: '/surgical-detail/:surgicalId/:surgicalName', exact: true, component: Surgical, title: ''},
  {path: '/surgical', exact: true, component: SurgicalClassify, title: ''},
  {path: '/subject-list', exact: true, component: SubjectList, title: '专题分类'},
  {path: '/subject-detail/:subjectId', exact: true, component: SubjectDetail, title: ''},
  {path: '/pdf-detail/', exact: true, component: PdfDetail, title: ''},
  {path: '/pdf-detail/agreement', exact: true, component: AgreementPdf, title: ''},
  {path: '/interview', exact: true, component: Interview, title: '博鳌访谈'},
  {path: '/user-recommend', exact: true, component: UserRecommend, title: '用户推荐'},
  {path: '/qr-code', exact: true, component: QrCode, title: ''},
  {path: '/contribute', exact: true, component: ContributeIndex, title: '手术电子杂志征稿'},
  {path: '/contribute/list', exact: true, component: ContributeList, title: '发布过的术友圈'},
  {path: '/contribute/log', exact: true, component: ContributeLog, title: '投稿记录'},
  {path: '/contribute/agreement', exact: true, component: ContributeAgreement, title: '投稿协议'},
  {path: '/solicit-contribute', exact: true, component: ContributeIndexV2, title: '肝胆手术视频大赛'},
  {path: '/solicit-contribute/list', exact: true, component: ContributeListV2, title: '发布过的术友圈'},
  {path: '/solicit-contribute/log', exact: true, component: ContributeLogV2, title: '投稿记录'},
  {path: '/solicit-contribute/agreement', exact: true, component: ContributeAgreementV2, title: '投稿协议'},
  {path: '/system/clean', exact: true, component: SystemLocalClean, title: '清除缓存'},

  {path: '/active-page/scalpel', exact: true, component: ActiveScalpel, title: '全国手术视频大赛'},

  {path: '/contribute-page/:topicId', exact: true, component: ContributeIndexPage, title: ''},
  {path: '/contribute-page/list/:topicId', exact: true, component: ContributeListPage, title: '发布过的术友圈'},
  {path: '/contribute-page/log', exact: true, component: ContributeLogPage, title: '投稿记录'},
  {path: '/contribute-page/agreement', exact: true, component: ContributeAgreementPage, title: '投稿协议'},
  {path: '/contribute-active-page/:topicId', exact: true, component: ContributeActivePage, title: ''},
  {path: '/playback-list', exact: true, component: PlaybackList, title: '直播回放列表'},
  {path: '/friendCircle-list', exact: true, component: FriendCircleList, title: '术友圈列表'},

  {path: '/course', exact: true, component: CourseHome, title: '课程'},
  {path: '/my-course', exact: true, component: MyCourse, title: '我的课程'},
  {path: '/course-order/:courseId/:orderNo', exact: true, component: CourseOrder, title: '订单详情'},
  {path: '/course-detail/:courseId', exact: true, component: CourseDetail, title: '课程详情'},
  {path: '/course-play/:courseId/:videoId', exact: true, component: CoursePlay, title: '课程视频'},
  {path: '/course-pay/:courseId', exact: true, component: CoursePay, title: '确认订单'}

]

export default routes
